export type Address = {
  street: string;
  city: string;
  state: string;
  zipCode: string;
  county: string;
  latitude: number;
  longitude: number;
};

export const initialMapAddress: Address = {
  street: '', //address we show in the input
  city: '',
  state: '',
  zipCode: '',
  county: '',
  latitude: 0,
  longitude: 0,
};

export interface AddressComponent {
  long_name: string; // Full name of the component, e.g., "California"
  short_name: string; // Abbreviated name, e.g., "CA"
  types: string[]; // Array of types describing this component, e.g., ["administrative_area_level_1", "political"]
}
